module.exports = "https://milano-network.servercdn.it/static/img/logo_infinity.svg?51f821f9ded2eee5a659b31fa6d25b71";